export const LineColor: ReadonlyMap<string, string> = new Map([
  ["GR", "#38b000"],
  ["RD", "#d90429"],
  ["OR", "#fb6107"],
  ["YL", "#ffd700"],
  ["SV", "#B2B4B2"],
  ["BL", "#3772FF"],
]);

export enum DotColor {
  On = "#EBB100",
  Dim = "#7a7157",
  Off = "#111111",
  Heading = "#EF1800",
  Highlight = "#9BD400",
}

export enum TextColor {
  Dark = "black",
  Light = "white",
}

export const BACKGROUND_COLOR = "black";
